<!--suppress HtmlUnknownTag -->
<vuejs3-todo>
    Ready
</vuejs3-todo>

<template>
    <section class="forgotten-password-request-page">
        <h1 v-if="requestIsSent">{{ i18n.requestIsSent }}</h1>
        <h1 v-else-if="error">{{ i18n._error }}</h1>
        <form v-else
              @submit.prevent="sendRequest"
        >
            <p>
                <template v-if="$i18n.lang === 'fr'">
                    Nous ne connaissons pas votre mot de passe, mais pas de panique ! Vous pouvez en choisir un
                    nouveau ! Renseignez simplement votre adresse email :
                </template>
                <template v-else-if="$i18n.lang === 'de'">
                    Wir kennen Ihr Passwort nicht, aber keine Panik! Sie können ein neues Passwort vergeben!
                    Geben Sie einfach Ihre E-Mail-Adresse ein:
                </template>
                <template v-else>
                    We don't know your password, but no panic! You'll be able to choose a new one! Just enter your email
                    address:
                </template>
            </p>
            <input type="email"
                   v-model="inputEmail"
                   required
                   :placeholder="i18n.placeholder"
                   :aria-label="i18n.label"
                   data-cy="forgotten-password-input"
            />
            <div>
                <router-link to="/login">{{ i18n._cancel }}</router-link>
                <button type="submit">{{ i18n.submit }}</button>
            </div>
        </form>

    </section>
</template>

<script>
    import axios from "@/outside/axios";

    const i18n = {
        de: {
            label: "E-Mail-Adresse",
            placeholder: "E-Mail-Adresse",
            requestIsSent: "Sie werden umgehend eine E-Mail erhalten!",
            submit: "Weiter"
        },
        en: {
            label: "Email address",
            placeholder: "Email address",
            requestIsSent: "You will receive an email very soon!",
            submit: "Continue"
        },
        fr: {
            label: "Adresse email",
            placeholder: "Adresse email",
            requestIsSent: "Vous allez recevoir un email très vite !",
            submit: "Continuer"
        }
    };

    export default {
        computed: {
            /**
             * @return {Object}
             */
            i18n() {
                return this.$i18n.strings(i18n, this.$options.name);
            }
        },
        data() {
            return {
                error: false,
                inputEmail: this.email,
                requestIsSent: false
            };
        },
        methods: {
            /**
             * Sends a "forgotten password" email through Echoline API.
             * @return {Promise}
             */
            sendRequest() {
                return axios.post("/rpc", {
                    action: "customers.password.forgotten",
                    params: {
                        email: this.inputEmail,
                        url: process.env.VUE_APP_FORGOTTEN_PASSWORD_URL
                    }
                }, {
                    validateStatus: status => [200,400].includes(status)
                }).then((response) => {
                    // noinspection JSUnresolvedVariable
                    if (
                        response.status === 400
                        && (
                            response.resource !== "error"
                            || response.data.code !== "1"
                        )
                    ) {
                        const error = new Error();
                        error.response = response;
                        throw error;
                    }

                    this.requestIsSent = true;
                }).catch(() => {
                    this.error = true;
                });
            }
        },
        name: "ForgottenPasswordRequestPage",
        props: {
            email: {
                type: String
            }
        },
        watch: {
            email: {
                handler(value) {
                    this.inputEmail = value;
                },
                immediate: true
            }
        }
    }
</script>

<style lang="scss">
    @import "../../colors";
    @import "../../mixins";
    @import "../../variables";

    .forgotten-password-request-page {
        display: flex;
        height: 100vh;
        width: 100vw;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        background-image: url("/img/outside_forgotten-password-request-page_background.svg");
        background-position: bottom right;
        background-repeat: no-repeat;
        background-size: 32%;

        form {
            width: 40%;
            background-color: white;
            box-shadow: 0 0 4px black;
            border-radius: 8px;
            box-sizing: border-box;
            padding: 0 32px;

            p {
                margin: 32px 0;
            }

            input {
                font-family: inherit;
                font-size: inherit;
                line-height: 24px;
                border: 1px solid $color-border;
                padding: 7px 11px;
                border-radius: 4px;
                box-sizing: border-box;
                width: 100%;

                &:focus,
                &:active {
                    outline: none;
                    border-color: $color-blue-medium;
                }
            }

            div {
                display: flex;
                justify-content: space-between;
                line-height: 40px;
                margin: 32px 0;

                a {
                    color: $color-font-light;
                    text-decoration: none;
                    margin-left: 13px;
                }

                button {
                    line-height: 38px;
                    border: 1px solid $color-mint;
                    background-color: $color-mint;
                    color: white;
                    font-family: inherit;
                    font-size: inherit;
                    padding: 0 12px;
                    border-radius: 4px;
                    cursor: pointer;
                    @include transition(color, background-color);

                    &:hover {
                        color: $color-mint;
                        background-color: transparent;
                    }
                }
            }
        }

        h1 {
            font-weight: $font-weight-bold;
        }
    }
</style>
